import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {InputTextModule} from 'primeng/inputtext';
import {ButtonModule} from 'primeng/button';
import {MenuModule} from 'primeng/menu';
import { UpdateUserComponent } from './update-user/update-user.component';
import {UserManagementComponent} from './user-management.component';
import { RolesManagementComponent } from './roles-management/roles-management.component';
import {DividerModule} from 'primeng/divider';
import {DropdownModule} from 'primeng/dropdown';
import {MultiSelectModule} from 'primeng/multiselect';
import {DialogModule} from 'primeng/dialog';
import {ReactiveFormsModule} from '@angular/forms';
import {PaginatorModule} from 'primeng/paginator';
import {ToastModule} from 'primeng/toast';
import {InputSwitchModule} from 'primeng/inputswitch';
import {PasswordModule} from 'primeng/password';
import { UpdateRolesComponent } from './roles-management/update-roles/update-roles.component';
import {CheckboxModule} from 'primeng/checkbox';
import { CustomerOnboardingComponent } from './customer-onboarding/customer-onboarding.component';
import {RippleModule} from "primeng/ripple";
import {ConfirmDialogModule} from "primeng/confirmdialog";

@NgModule({
    declarations: [UserManagementComponent, UpdateUserComponent, RolesManagementComponent, UpdateRolesComponent, CustomerOnboardingComponent],
    imports: [
        ButtonModule,
        InputTextModule,
        CommonModule,
        MenuModule,
        DividerModule,
        DropdownModule,
        MultiSelectModule,
        DialogModule,
        ReactiveFormsModule,
        ToastModule,
        InputSwitchModule,
        PasswordModule,
        PaginatorModule,
        CheckboxModule,
        RippleModule,
        ConfirmDialogModule
    ]
})
export class UserManagementModule {
}
